export default __webpack_public_path__ + "static/media/3dtube.0daa3930.png";